import storage from "/@/cool/utils/storage";
import { normalizeLang } from "/@/utils/normalizeLang";

export function getCurrentLang(url?: string) {
	const href = url || (typeof window === "undefined" ? "" : window.location.href);
	let urlLang = "";

	if (href) {
		try {
			urlLang = new URL(href, typeof window === "undefined" ? undefined : window.location.href)
				.searchParams.get("lang") || "";
		} catch {
			urlLang = "";
		}
	}
	const lang = normalizeLang(urlLang || storage.get("lang") || storage.get("i18nextLng"));

	if (lang) {
		storage.set("lang", lang);
		storage.set("i18nextLng", lang);
	}

	return lang;
}
